import anime from 'animejs';

const title = (el) => {
  const basicTimeline = anime.timeline();

  basicTimeline.add({
    targets: el.node,
    duration: 0,
    opacity: 1,
    offset: 0,
  })
  .add({
    targets: el.instance[0].lines,
    duration: 450,
    delay: 0,
    opacity: [0, 1],
    translateY: ['100%', '0%'],
    easing: 'easeInOutCubic',
    offset: 0,
  });

  basicTimeline.finished.then(() => {
    el.node.removeAttribute('js-anim');
    el.node.innerHTML = el.innerHtml;
  });

  return basicTimeline;
};

export default title;
